const recordOf = (value: unknown): Record<string, unknown> =>
	value && typeof value === 'object' ? value as Record<string, unknown> : {};

const hasText = (value: unknown): boolean =>
	typeof value === 'string' && value.replace(/<[^>]*>/g, '').replace(/&nbsp;|&#160;/g, ' ').trim() !== '';

const hasQuestions = (value: unknown): boolean => {
	if (Array.isArray(value)) return value.some(hasQuestions);
	const record = recordOf(value);
	if (hasText(record.question)) return true;
	return ['questions', 'preQuiz', 'postQuiz', 'assessment', 'assessmentQuiz', 'other', 'data', 'content', 'items', 'item', 'children']
		.some(key => record[key] != null && hasQuestions(record[key]));
};

const hasSlides = (value: unknown): boolean => {
	if (Array.isArray(value)) return value.some(hasSlides);
	const record = recordOf(value);
	if (record.slides != null) return hasSlides(record.slides);
	return ['slideTitle', 'title', 'leadText', 'illustrationImage', 'content']
		.some(key => hasText(record[key]));
};

/** Audience needs actual content; authoring keeps its existing editing controls. */
export const getAudienceContentVisibility = (source: unknown, collectionMode: unknown) => {
	const unrestricted = String(collectionMode ?? '').trim().toLowerCase() !== 'audience';
	const item = recordOf(source);
	return {
		preQuiz: unrestricted || (item.activePreQuiz === true && hasQuestions(item.preQuiz)),
		postQuiz: unrestricted || (item.activePostQuiz === true && hasQuestions(item.postQuiz)),
		assessment: unrestricted || (item.activeAssessment === true && (hasQuestions(item.assessment) || hasQuestions(item.assessmentQuiz))),
		podcast: unrestricted || (item.activePodcast === true && hasText(item.file_url)),
		presentation: unrestricted || (item.activePresentation === true && hasSlides(item.podcastSlideshow)),
		keyMessages: unrestricted || hasText(recordOf(item.mainOutcome).keyMessages),
	};
};
